export const RENEWALS_PORTAL_URL = '/renewals';
export const HOME_URL = '/';
export const PRODUCT_LIST_URL = '/renewals/:branchRouteCustomerId';
export const PRODUCT_DETAILS_URL =
  '/renewals/:branchRouteCustomerId/line-items/:lineItemId';
export const COMPLETED_RENEWALS_PORTAL_URL = '/completed-renewals';
export const REPORTS_PORTAL_URL = '/reports';
export const MANAGED_RESTROOM_SERVICES_URL = '/managed-restroom-services';
export const MRS_CUSTOMERS_URL = '/managed-restroom-services/customers';
export const MRS_ORDER_URL =
  '/managed-restroom-services/order-workflow/:orderId';
export const MRS_ORDER_APPROVE_URL =
  '/managed-restroom-services/orders/:orderId';
export const MRS_THANKYOU = '/managed-restroom-services/thankyou';
export const SIGN_IN_URL = '/sign-in';
export const UNAUTHED_RENEWAL_VIEW_URL = '/customer/renewal';
export const UNAUTHED_ADD_NEW_PRODUCT_VIEW_URL = '/customer/add-new-product';
export const THANK_YOU_URL = '/thank-you';
export const IMITATE_EMPLOYEE_URL = '/imitate';
export const ADMIN_PANEL_URL = '/admin-panel';
export const SELECT_BRANCHES_URL = '/select-branches';
export const INACTIVE_BRANCHES_URL = '/inactive-branches';
export const BRANCH_OVERRIDES = '/branch-overrides';
export const TERMS_AND_CONDITIONS_URL =
  '/customer/renewal/terms-and-conditions';
export const CUSTOMER_SIGNATURE_URL = '/customer/renewal/signature';
export const RENEWAL_NOT_AVAILABLE_URL = '/renewal-not-available';
